import React from 'react';
import coverbackground from '../../assets/on-the-go.jpg';
import ReusableScrollCard from '../../components/ReusableScrollcard/ReusableScrollcard';

class ScrollOnthego extends React.Component {
  render () { 
   return(
  
  <ReusableScrollCard             
    
        
        description="On the go"
        coverbackground={coverbackground}
     />
  
  );
 }
}   

export default ScrollOnthego;